import { http } from "@canvas/api";
import store from "@/store";

export interface BouncerUserPermissionsCheckPostReq {
  endpoint: "bouncer.v3.users.check-access";
  body: permissionsRequestBody;
}

export interface permissionsRequestBody {
  application_name: string;
  permissions: Array<string>;
}

export interface BouncerUserPermissionsCheckPostRes {}

export function post(
  req: BouncerUserPermissionsCheckPostReq
): Promise<BouncerUserPermissionsCheckPostRes> {
  const endpoint = store.state.appModule.config && store.state.appModule.config.serviceConfigMap.bouncer;
  return http
    .POST(`/${endpoint}/v3/users/check-access`, JSON.stringify(req.body))
    .then((response: BouncerUserPermissionsCheckPostRes) => {
      // validate response here
      return response;
    })
    .catch((err: Error) => {
      return Promise.reject(err);
    });
}
